// @ts-check

import { checkStrings } from 'libs/types/checkTypes';
import USER from '../ts/profileEditorEnum';
import { updateAddresses, deleteAddresses } from './updateAddresses';

/**
 * @function handleProfileEditorUser
 * @param {string} name
 * @param {*} payload
 * @param {EditorUserType} user
 * @param {function} setUser - setEditorUser
 * @return {void}
 */
function handleProfileEditorUser(name, payload, user, setUser) {
	checkStrings(name);

	switch (name) {
		case USER.FIRST_NAME:
		case USER.LAST_NAME:
		case USER.USERNAME:
		case USER.EMAIL_WORK:
		case USER.EMAIL_PERSONAL:
		case USER.EMAIL_OTHER:
		case USER.NOTES:
			setUser((prev) => ({ ...prev, [name]: payload.trim() }));
			break;
		case USER.PASSWORD:
			setUser((prev) => ({ ...prev, [name]: payload.trim() }));
			if (payload.trim().length === 0) {
				setUser((prev) => ({ ...prev, [USER.CONFIRM_PASSWORD]: '' }));
			}
			break;
		case USER.CONFIRM_PASSWORD:
			setUser((prev) => ({ ...prev, [name]: payload.trim() }));
			break;
		case USER.LANGUAGES:
		case USER.CONTACT_TYPES:
		case USER.ROLE_GROUPS:
		case USER.COMPANIES:
		case USER.ACCESSIBLE:
			setUser((prev) => ({ ...prev, [name]: payload }));
			break;
		case USER.PHONE_WORK:
		case USER.PHONE_MOBILE:
		case USER.PHONE_OTHER:
			setUser((prev) => ({
				...prev,
				[name]: payload[name].trim(),
				[`${name}DialCode`]: payload[`${name}DialCode`].trim(),
				[`${name}CountryCode`]: payload[`${name}CountryCode`].trim(),
				[`${name}Ext`]: payload[`${name}Ext`].trim(),
			}));
			break;
		case USER.ADDRESS_WORK:
		case USER.ADDRESS_HOME:
		case USER.ADDRESS_OTHER:
			const updatedAddresses = updateAddresses(name, payload, user[USER.ADDRESSES]);
			setUser((prev) => ({ ...prev, [USER.ADDRESSES]: updatedAddresses }));
			break;
		case USER.DELETE_ADDRESS:
			const deletedAddresses = deleteAddresses(payload, user[USER.ADDRESSES]);
			setUser((prev) => ({ ...prev, [USER.ADDRESSES]: deletedAddresses }));
			break;
		case USER.IMAGE:
			setUser((prev) => ({ ...prev, [USER.IMAGE]: payload.preview, [USER.FILE]: payload.file }));
			break;
		default:
			const msg = 'There is an invalid name in the handleProfileEditorUser() function.';
			throw new Error(msg);
	}
}

export default handleProfileEditorUser;
